import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, useTheme, Box, Typography } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CenterContainer from '../../theme/CenterContainer.js';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { retrieveContentfulImage } from '../../common/image.js';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import YoutubePlayer from '../../widgets/video/YoutubePlayer.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import { textStyleType } from '../../common/PropShapes.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      width: "100%"
    },
    item: _defineProperty({
      width: "50%"
    }, theme.breakpoints.down("sm"), {
      width: "100%"
    }),
    image: _defineProperty({
      width: "100%",
      borderRadius: "14px"
    }, theme.breakpoints.only("sm"), {
      objectFit: "cover",
      height: "100%"
    }),
    greenHighlightedTitle: {
      background: "linear-gradient(bottom, ".concat(theme.palette.primary[100], " 60%, transparent 40%)"),
      display: "inline",
      height: theme.spacing(4.5)
    },
    cta: {
      marginTop: theme.spacing(5)
    },
    ctaLabel: {
      color: theme.palette.text.white
    },
    ctaLabelPrimary: {
      color: theme.palette.text.black
    },
    imageDescription: _defineProperty({
      color: theme.palette.grey["800"],
      marginTop: theme.spacing(1)
    }, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(0.5)
    })
  };
});

//titleStyle in this component type will be applied only to the inner titles -> steps.title 
var StepsImageTextCta = function StepsImageTextCta(_ref) {
  var steps = _ref.steps,
    bgColor = _ref.bgColor,
    titleStyle = _ref.titleStyle,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var classes = useStyles();
  var theme = useTheme();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var getFlexDirection = function getFlexDirection(index) {
    if (isExtraSmallScreen()) {
      return "column";
    }
    return index % 2 !== 0 ? "row" : "row-reverse";
  };
  var getHeadingStyleClass = function getHeadingStyleClass(name) {
    switch (name) {
      case "Green highlighted":
        return classes.greenHighlightedTitle;
      default:
        return "";
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    className: classes.wrapper
  }, /*#__PURE__*/React__default.createElement(CenterContainer, {
    maxWidth: theme.breakpoints.width("lg")
  }, title && /*#__PURE__*/React__default.createElement(Box, {
    pt: 7.5
  }, /*#__PURE__*/React__default.createElement(Typography, {
    align: "center",
    variant: "h3",
    component: "h2"
  }, title)), subtitle && /*#__PURE__*/React__default.createElement(Box, {
    mt: isExtraSmallScreen() ? 3 : 7.5
  }, /*#__PURE__*/React__default.createElement(Typography, {
    align: "left",
    variant: "body1"
  }, subtitle)), /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    px: isExtraSmallScreen() ? 0 : 3,
    pt: 10
  }, steps === null || steps === void 0 ? void 0 : steps.map(function (item, index) {
    var _item$video, _item$image, _item$image2, _item$image3, _titleStyle$textAlign, _item$button, _item$button2, _BUTTON_TYPES$item$bu, _BUTTON_TYPES$item$bu2, _BUTTON_TYPES$item$bu3, _item$button3, _item$button4;
    return /*#__PURE__*/React__default.createElement(Box, {
      mt: index !== 0 ? 6 : 0,
      key: index,
      display: "flex",
      flexDirection: getFlexDirection(index)
    }, /*#__PURE__*/React__default.createElement(Box, {
      className: classes.item
    }, item !== null && item !== void 0 && (_item$video = item.video) !== null && _item$video !== void 0 && _item$video.url ? /*#__PURE__*/React__default.createElement(YoutubePlayer, {
      videoUrl: item.video.url,
      videoDescription: item.video.description,
      imageUrl: item.video.image
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (item === null || item === void 0 || (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      src: retrieveContentfulImage(item === null || item === void 0 || (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.url, {
        width: 600
      }),
      className: classes.image,
      alt: (item === null || item === void 0 || (_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.title) || ""
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      className: classes.imageDescription,
      align: "center"
    }, item.image.description)))), /*#__PURE__*/React__default.createElement(Box, {
      mt: 4,
      className: classes.item,
      ml: index % 2 !== 0 && !isExtraSmallScreen() ? 5 : 0,
      mr: index % 2 === 0 && !isExtraSmallScreen() ? 5 : 0
    }, (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/React__default.createElement(Box, {
      textAlign: titleStyle === null || titleStyle === void 0 || (_titleStyle$textAlign = titleStyle.textAlignment) === null || _titleStyle$textAlign === void 0 ? void 0 : _titleStyle$textAlign.toLowerCase()
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: titleStyle !== null && titleStyle !== void 0 && titleStyle.headingVariant ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingVariant : "h3",
      component: "h2",
      className: titleStyle !== null && titleStyle !== void 0 && titleStyle.headingStyle ? getHeadingStyleClass(titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingStyle) : ""
    }, item === null || item === void 0 ? void 0 : item.title)), /*#__PURE__*/React__default.createElement(Box, {
      mt: 3
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1",
      component: "div"
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: item === null || item === void 0 ? void 0 : item.description
    })))), (item === null || item === void 0 || (_item$button = item.button) === null || _item$button === void 0 ? void 0 : _item$button.label) && (item === null || item === void 0 || (_item$button2 = item.button) === null || _item$button2 === void 0 ? void 0 : _item$button2.url) && /*#__PURE__*/React__default.createElement(CustomButton, {
      className: classes.cta,
      variant: (_BUTTON_TYPES$item$bu = BUTTON_TYPES[item.button.type]) === null || _BUTTON_TYPES$item$bu === void 0 ? void 0 : _BUTTON_TYPES$item$bu.variant,
      color: (_BUTTON_TYPES$item$bu2 = BUTTON_TYPES[item.button.type]) === null || _BUTTON_TYPES$item$bu2 === void 0 ? void 0 : _BUTTON_TYPES$item$bu2.color,
      href: item.button.url
    }, /*#__PURE__*/React__default.createElement(Typography, {
      className: (((_BUTTON_TYPES$item$bu3 = BUTTON_TYPES[item === null || item === void 0 || (_item$button3 = item.button) === null || _item$button3 === void 0 ? void 0 : _item$button3.type]) === null || _BUTTON_TYPES$item$bu3 === void 0 ? void 0 : _BUTTON_TYPES$item$bu3.color) || "primary") === "primary" ? classes.ctaLabelPrimary : classes.ctaLabel,
      variant: "subtitle1",
      component: "span"
    }, item === null || item === void 0 || (_item$button4 = item.button) === null || _item$button4 === void 0 ? void 0 : _item$button4.label))));
  }))));
};
StepsImageTextCta.propTypes = {
  steps: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.string,
    description: PropTypes__default.string,
    image: PropTypes__default.shape({
      url: PropTypes__default.string,
      description: PropTypes__default.string
    }),
    video: PropTypes__default.shape({
      url: PropTypes__default.string,
      description: PropTypes__default.string
    }),
    button: PropTypes__default.object
  })),
  bgColor: PropTypes__default.string,
  titleStyle: PropTypes__default.shape(textStyleType),
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string
};

export { StepsImageTextCta, StepsImageTextCta as default };
//# sourceMappingURL=StepsImageTextCta.js.map
